<template>
  <div class="periodic-purchase">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <a :href="baseUrl">{{ this.shopName }}</a></el-breadcrumb-item
      >
      <el-breadcrumb-item>{{ $t('ec-line029.title') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <purchase-form :is-back004="isBack004" />
  </div>
</template>

<script>
import PurchaseForm from '@/components/ec-line029/PurchaseForm.vue'
import BreadcrumbMixin from '@/mixins/breadcrumb'

export default {
  components: {
    PurchaseForm,
  },
  mixins: [BreadcrumbMixin],
  beforeRouteEnter(to, from, next) {
    next((vm) => vm.setIsBackFromLine004(from.name === 'EC_LINE004'))
  },
  data() {
    return {
      isBack004: false,
    }
  },
  methods: {
    setIsBackFromLine004(value) {
      this.isBack004 = value
    },
  },
  metaInfo() {
    return {
      title: this.$t('ec-line029.metaTitleNormal'),
      script: [
        {
          src: process.env.VUE_APP_GMO_LIB_URL,
        },
      ],
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('ec-line029.normalDescription', { shop_name: this.shopName }),
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$t('ec-line029.normalKeyword', { shop_name: this.shopName }),
        },
        {
          vmid: 'robots',
          name: 'robots',
          content: this.Constants.META_TAG.NO_INDEX_NO_FOLLOW,
        },
      ],
    }
  },
}
</script>
